import React from 'react';
import propTypes from 'prop-types';

export const InvoiceIcon = ({ size, color, variant }) => {
  const sizeInPixel = `${size}px`;
  return (
    <svg
      width={sizeInPixel}
      height={sizeInPixel}
      className={variant}
      fill={color}
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 513.164 513.164"
      enableBackground="new new 0 0 513.164 513.164"
      xmlSpace="preserve"
    >
      <g>
        <g>
          <circle cx="118.083" cy="244.945" r="11.636" />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M472.992,1.745c-3.491-2.327-8.146-2.327-11.636,0l-29.091,19.782L404.337,2.909c-3.491-2.327-9.309-2.327-12.8,0
			l-29.091,18.618L334.519,2.909c-3.491-2.327-9.309-2.327-12.8,0l-29.091,18.618L264.701,2.909c-3.491-2.327-9.309-2.327-12.8,0
			L222.81,21.527L194.883,2.909c-3.491-2.327-9.309-2.327-12.8,0l-29.091,18.618L125.064,2.909c-3.491-2.327-9.309-2.327-12.8,0
			L83.174,21.527L55.246,2.909c-3.491-2.327-8.145-2.327-11.636,0c-4.655,1.164-6.982,4.655-6.982,9.309v488.727
			c0,4.655,2.327,8.145,5.818,10.473c3.491,2.327,8.145,2.327,11.636,0l29.091-19.782l27.927,18.618c3.491,2.327,9.309,2.327,12.8,0
			l27.927-18.618l27.927,18.618c3.491,2.327,9.309,2.327,12.8,0l27.927-18.618l27.927,18.618c3.491,2.327,9.309,2.327,12.8,0
			l27.927-18.618l27.927,18.618c3.491,2.327,9.309,2.327,12.8,0l27.927-18.618l27.927,18.618c3.491,2.327,9.309,2.327,12.8,0
			l27.927-18.618l27.927,18.618c2.327,1.164,4.655,2.327,6.982,2.327c2.327,0,3.491,0,5.818-1.164
			c3.491-2.327,5.818-5.818,5.818-10.473V12.218C478.81,7.564,476.483,4.073,472.992,1.745z M439.246,467.2
			c-3.491-2.327-9.309-2.327-12.8,0l-29.091,19.782l-27.927-18.618c-2.327-1.164-4.655-2.327-6.982-2.327s-4.655,1.164-6.982,2.327
			l-27.927,18.618l-27.927-18.618c-3.491-2.327-9.309-2.327-12.8,0l-29.091,18.618l-27.927-18.618c-3.491-2.327-9.309-2.327-12.8,0
			l-29.091,18.618l-27.927-18.618c-3.491-2.327-9.309-2.327-12.8,0l-29.091,18.618l-27.927-18.618c-3.491-2.327-9.309-2.327-12.8,0
			L61.064,480V34.327l16.291,11.636c3.491,2.327,9.309,2.327,12.8,0l27.927-19.782L146.01,44.8c3.491,2.327,9.309,2.327,12.8,0
			l29.091-18.618L215.828,44.8c3.491,2.327,9.309,2.327,12.8,0l29.091-18.618L285.646,44.8c3.491,2.327,9.309,2.327,12.8,0
			l29.091-18.618L355.464,44.8c3.491,2.327,9.309,2.327,12.8,0l29.091-18.618L425.283,44.8c3.491,2.327,9.309,2.327,12.8,0
			l16.291-11.636v444.842L439.246,467.2z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M374.083,303.127H350.81c-6.982,0-11.636-4.655-11.636-11.636s4.655-11.636,11.636-11.636h34.909
			c6.982,0,11.636-4.655,11.636-11.636s-4.655-11.636-11.636-11.636h-11.636v-11.636c0-6.982-4.655-11.636-11.636-11.636
			s-11.636,4.655-11.636,11.636v11.636c-19.782,0-34.909,15.127-34.909,34.909c0,19.782,15.127,34.909,34.909,34.909h23.273
			c6.982,0,11.636,4.655,11.636,11.636c0,6.982-4.655,11.636-11.636,11.636h-34.909c-6.982,0-11.636,4.655-11.636,11.636
			s4.655,11.636,11.636,11.636h11.636v11.636c0,6.982,4.655,11.636,11.636,11.636s11.636-4.655,11.636-11.636v-11.636
			c19.782,0,34.909-15.127,34.909-34.909C408.992,318.255,393.864,303.127,374.083,303.127z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M350.81,105.309H164.628c-6.982,0-11.636,4.655-11.636,11.636s4.655,11.636,11.636,11.636H350.81
			c6.982,0,11.636-4.655,11.636-11.636S357.792,105.309,350.81,105.309z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M304.264,151.855h-93.091c-6.982,0-11.636,4.655-11.636,11.636c0,6.982,4.655,11.636,11.636,11.636h93.091
			c6.982,0,11.636-4.655,11.636-11.636C315.901,156.509,311.246,151.855,304.264,151.855z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M222.81,233.309h-58.182c-6.982,0-11.636,4.655-11.636,11.636s4.655,11.636,11.636,11.636h58.182
			c6.982,0,11.636-4.655,11.636-11.636S229.792,233.309,222.81,233.309z"
          />
        </g>
      </g>
      <g>
        <g>
          <circle cx="118.083" cy="291.491" r="11.636" />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M234.446,279.855h-69.818c-6.982,0-11.636,4.655-11.636,11.636s4.655,11.636,11.636,11.636h69.818
			c6.982,0,11.636-4.655,11.636-11.636S241.428,279.855,234.446,279.855z"
          />
        </g>
      </g>
      <g>
        <g>
          <circle cx="118.083" cy="338.036" r="11.636" />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M211.174,326.4h-46.545c-6.982,0-11.636,4.655-11.636,11.636c0,6.982,4.655,11.636,11.636,11.636h46.545
			c6.982,0,11.636-4.655,11.636-11.636C222.81,331.055,218.155,326.4,211.174,326.4z"
          />
        </g>
      </g>
      <g>
        <g>
          <circle cx="118.083" cy="384.582" r="11.636" />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M257.719,372.945h-93.091c-6.982,0-11.636,4.655-11.636,11.636s4.655,11.636,11.636,11.636h93.091
			c6.982,0,11.636-4.655,11.636-11.636S264.701,372.945,257.719,372.945z"
          />
        </g>
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
};
InvoiceIcon.propTypes = {
  size: propTypes.number,
  color: propTypes.string,
  variant: propTypes.string,
};
InvoiceIcon.defaultProps = {
  size: 18,
  color: 'black',
  varient: '',
};
